import CaseConfirmation from './CaseConfirmation';

export default CaseConfirmation;
